import React from 'react';
import { Button, Popover, Tag } from 'antd';
import { NavLink } from 'react-router-dom';

export const linkingColumns = (t) => [
  {
    title: t('Type of Subject'),
    dataIndex: 'type',
    key: 'type',
    show: true,
    search: true,
    render: type => t(type),
    searchType: 'dropdown',
  },
  {
    title: t('System ID'),
    dataIndex: 'datastakeId',
    key: 'datastakeId',
    show: true,
    sorter: (a, b) => ('' + a.id).localeCompare(b.id),
    render: (id, item) => {
      let link = '';
      switch (item.type) {
        case 'stakeholder':
          link = `/app/pme/stakeholders/${id}`;
          break;
        case 'event':
          link = `/app/pme/events/${id}`;
          break;
        case 'location':
          link = `/app/pme/locations/${id}`;
          break;
        case 'lir':
          link = `/app/pme/lir/${id}`;
          break;
        default:
          link = '#';
          break;
      }
      return <NavLink className="projectLink" to={link}>
        {id}
      </NavLink>
    },
    search: true,
  },
  {
    title: t('Name / Type'),
    dataIndex: 'name',
    key: 'name',
    show: true,
    render: (name) => t(name),
    search: true,
  },
  {
    title: t('Connected as'),
    dataIndex: 'usedAs',
    key: 'usedAs',
    show: true,
    render: (used) => {
      const language = localStorage.getItem('datastakeLng') || 'en';
      return used[language];
    },
    search: true,
  },
];

const cols = (t) => [
  {
    title: t('ID'),
    dataIndex: 'id',
    key: 'id',
    show: true,
    sorter: (a, b) => ('' + a.id).localeCompare(b.id),
    render: id => (
      <NavLink className="projectLink" to={`/app/pme/scp/${id}`}>
        {id}
      </NavLink>
    ),
    search: true,
  },
  {
    title: t('Name'),
    dataIndex: 'organisationName',
    defaultSortOrder: 'ascend',
    sorter: (a, b) => ('' + a?.organisationName).localeCompare(b?.organisationName),
    key: 'organisationName',
    show: true,
    primarySearch: true,
  },
  {
    title: t('Position in Supply Chain'),
    dataIndex: 'positionInSupplyChain',
    key: 'positionInSupplyChain',
    show: true,
    search: true,
    searchType: 'dropdown',
    render: pInSupplyChain => {
      pInSupplyChain = Array.isArray(pInSupplyChain) ? pInSupplyChain : [pInSupplyChain]
      const positionInSupplyChain = pInSupplyChain.slice(0, 2);
      const otherPositionInSupplyChain = pInSupplyChain.slice(2);
      const content = pInSupplyChain.map((p, i) => {
        return (
          <Tag key={i}>
            {p}
          </Tag>
        )
      })
      return positionInSupplyChain.length ? (
        <div style={{ display: 'flex', justifyContent: "space-between" }}>
          <div>
            {positionInSupplyChain.map((p, i) => {
              return (
                <Tag key={i}>
                  {p}
                </Tag>
              )
            })}
          </div>
          {pInSupplyChain.length > 2 ? (
            <Popover content={content} title={t('Position in Supply Chain')} trigger="click">
              <Button type="dashed" style={{ height: '22px', padding: '0 10px' }} >+{otherPositionInSupplyChain.length}</Button>
            </Popover>
          ) : null}
        </div>
      ) : null
    },
  },
  {
    title: t('Country'),
    dataIndex: 'country',
    key: 'country',
    show: true,
    search: true,
  },
  {
    title: t('Province'),
    dataIndex: 'province',
    key: 'province',
    show: true,
    search: true,
  },
  {
    title: t('Materials'),
    dataIndex: 'focusMaterial',
    key: 'focusMaterial',
    show: true,
    render: materials => {
      return materials ? (
        <>
          {(Array.isArray(materials) ? materials : [materials]).map((m, i) => {
            return (
              <Tag key={i}>
                {m.toUpperCase()}
              </Tag>
            )
          })}
        </>
      ) : null
    },
    search: true,
    searchType: 'dropdown',
  },
  {
    title: t('Status'),
    dataIndex: 'status',
    key: 'status',
    render: status => {
      const defaultStatus = { value: '--', label: '--', color: 'default' };
      const allStatuses = [
        { label: t('Identified'), value: 'Identified', color: 'default' },
        { label: t('In Progress'), value: 'In Progress', color: 'warning', },
        { label: t('Assessed'), value: 'Assessed', color: 'blue' },
        { label: t('Connected'), value: 'Connected', color: 'success' },
      ];
      const statusOptions = allStatuses.find(s => s.value === status) || defaultStatus;
      return (
        <Tag key={statusOptions.value} color={statusOptions.color || 'default'} >{statusOptions.label}</Tag>

      )
    },
    search: true,
    searchType: 'dropdown',
  },
]

export default cols;
